import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useCapabilitiesOptions } from './use-capabilities-options';

export function useCapabilities() {
  const { selectedOrganization: org } = useOrganizationContext();
  const options = useCapabilitiesOptions(org.id);

  return useQuery({
    ...options,
    enabled: Boolean(org.id), // TODO AWN-217933
  });
}
